module.exports = __webpack_public_path__ + "img/Geschenketag.7a612e66.jpg";